import { DOCUMENT, Location } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Cart } from '@features/cart/interfaces/cart.interface';
import { CartService } from '@features/cart/services/cart.service';
import { User } from '@features/user/interfaces/user.interface';
import { UserService } from '@features/user/services/user.service';
import {
  faAngleRight,
  faArrowLeft,
  faArrowRightFromBracket,
  faBagShopping,
  faBars,
  faBell,
  faCartShopping,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faCog,
  faComment,
  faCreditCard,
  faGauge,
  faGlobe,
  faHeart,
  faPlus,
  faStore,
  faUser,
  faWandMagicSparkles,
} from '@fortawesome/free-solid-svg-icons';
import { LayoutService } from '../../services/layout.service';
@Component({
  selector: 'fc-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  faBell = faBell;
  faCartShopping = faCartShopping;
  faUser = faUser;
  faBars = faBars;
  faCog = faCog;
  faArrowRightFromBracket = faArrowRightFromBracket;
  faChevronDown = faChevronDown;
  faStore = faStore;
  faGlobe = faGlobe;
  faAngleRight = faAngleRight;
  faCreditCard = faCreditCard;
  faPlus = faPlus;
  faGaouge = faGauge;
  faBagShopping = faBagShopping;
  faComment = faComment;
  faHeart = faHeart;
  faWandMagicSparkles = faWandMagicSparkles;
  faCheckDouble = faCheckDouble;
  faArrowLeft = faArrowLeft;
  faChevronLeft = faChevronLeft;
  user?: User;

  searchQuery = '';

  countries = [
    {
      id: 1,
      imgPath: '/assets/images/country/indonesia.svg',
      name: 'Indonesia',
      link: '#',
      active: false,
    },
    {
      id: 2,
      imgPath: '/assets/images/country/singapore.svg',
      name: 'Singapore',
      link: '#',
      active: false,
    },
    {
      id: 3,
      imgPath: '/assets/images/country/malaysia.svg',
      name: 'Malaysia',
      link: '#',
      active: false,
    },
    {
      id: 4,
      imgPath: '/assets/images/country/philippines.svg',
      name: 'Philippines',
      link: '#',
      active: false,
    },
    {
      id: 5,
      imgPath: '/assets/images/country/vietnam.svg',
      name: 'Vietnam',
      link: '#',
      active: false,
    },
    {
      id: 6,
      imgPath: '/assets/images/country/australia.svg',
      name: 'Australia',
      link: '#',
      active: false,
    },
  ];
  isMobileSearchShowed = false;
  showPromotion = false;
  cart: Cart = {} as Cart;
  mobileLayoutConfig: any;

  constructor(
    private userService: UserService,
    @Inject(DOCUMENT) private document: Document,
    private layoutService: LayoutService,
    private location: Location,
    private cartService: CartService
  ) {
    this.layoutService.showPromotion$.subscribe((showPromotion) => {
      this.showPromotion = showPromotion;
    });
    this.layoutService.mobileLayoutConfig$.subscribe((mobileLayoutConfig) => {
      this.mobileLayoutConfig = mobileLayoutConfig;
    });
  }

  ngOnInit(): void {
    this.userService.currentUserValue.subscribe((user) => {
      this.user = user;
      this.cartService.cart$.subscribe((cart: Cart) => {
        this.cart = cart;
      });
    });
  }

  @ViewChild('mobileSearchInput') mobileSearchInput: any;
  toggleMobileSearch() {
    this.isMobileSearchShowed = !this.isMobileSearchShowed;
    if (this.isMobileSearchShowed) {
      this.document.body.classList.add('overflow-hidden');
      this.mobileSearchInput.nativeElement.focus();
    } else {
      this.document.body.classList.remove('overflow-hidden');
    }
  }
  back() {
    this.location.back();
  }
}
